// See Velo API Referencebox1$0
// https://dev.wix.com/docs/velo/articles/api-overview/introduction
// Learn about plugins
// https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-blocks/site-plugins/about-site-plugins-in-blocks
// See list of plugin APIs needed to integrate with plugin slots
// https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/site-plugins/supported-wix-app-pages/about-slots

import wixEcomBackend from "wix-ecom-backend";
import wixEcomFrontend from "wix-ecom-frontend";
import {local} from 'wix-storage-frontend';

$w.onReady(function () {
    // Initialize your plugin code here. Make sure that your plugin has the required Plugin API properties to communicate with the plugin slot.  
});

$widget.onPropsChanged((oldProps, newProps) => {

});

$w('#button1').onClick((event) => 
{
    let decoded_json = JSON.parse($w('#input1').value);
    let redirect_to_page = decoded_json.redirect_to_page;
    let widget_type = decoded_json.widget_type;
    let widget_section = decoded_json.widget_section;
    let products = JSON.parse(decoded_json.products);
    let discount_code = decoded_json.discount_code;

    let line_items = [];

    for (let j = 0; j < products.length; j++)
    {
        let product_options = {};

        if (products[j].manage_variants && products[j].variant_id != "00000000-0000-0000-0000-000000000000")
        {
            product_options['variantId'] = products[j].variant_id;
        }
        else
        {
            let decoded_options     = JSON.parse(products[j].selected_options);

            if (decoded_options.length > 0)
            {
                product_options['options'] = [];
                let custom_text_fields  = [];

                for (let i = 0; i < decoded_options.length; i++)
                {
                    let current_option = decoded_options[i];

                    if (current_option.custom_text && current_option.custom_text == "yes")
                    {
                        custom_text_fields[current_option.name] = current_option.value;
                    }
                    else
                    {
                        if (current_option.type && current_option.type == "color")
                        {
                            let option_value = (current_option.description && current_option.description.length > 0) ? current_option.description : current_option.value;
                            product_options['options'][current_option.name] = option_value;
                        }
                        else
                        {
                            product_options['options'][current_option.name] = current_option.value;
                        }
                    }
                }

                if (custom_text_fields.length > 0)
                {
                    product_options['customTextFields'] = custom_text_fields;
                }
            }
        }

        let item = {
            catalogReference: {
                appId: "215238eb-22a5-4c36-9e7b-e7c08025e04e",
                catalogItemId: products[j].product_id,
            },
            quantity: products[j].quantity,
        };

        if (Object.keys(product_options).length > 0)
        {
            item['catalogReference']['options'] = product_options;
        }
        line_items.push(item);
    }

    let options = {
        lineItems: line_items,
    };

    console.log(options);

    if (widget_type == "product_upsell")
    {
        if (decoded_json.selected_offer_type == "upsell" && decoded_json.upsell_product_id.length > 0)
        {
            wixEcomBackend.currentCart.getCurrentCart()
            .then((current_cart_details) => 
            {   
                let delete_items_ids = [];

                if (current_cart_details.lineItems.length > 0)
                {
                    for (let i = 0; i < current_cart_details.lineItems.length; i++)
                    {
                        if (current_cart_details.lineItems[i].catalogReference.catalogItemId == decoded_json.upsell_product_id)
                        {
                            delete_items_ids.push(current_cart_details.lineItems[i]._id);
                        }
                    }
                }

                if (delete_items_ids.length > 0)
                {
                    wixEcomBackend.currentCart.removeLineItemsFromCurrentCart(delete_items_ids);
                }
            });
        }
    }

    wixEcomBackend.currentCart.addToCurrentCart(options)
    .then(async (updatedCart) => 
    {
        let cart_details = [];

        if (updatedCart.cart.lineItems.length > 0)
        {
            for (let i = 0; i < updatedCart.cart.lineItems.length; i++)
            {
                let item = updatedCart.cart.lineItems[i];
                let product_id = item.catalogReference.catalogItemId;
                let product_title = item.productName.original;
                let price = item.fullPrice.amount;
                let sku = item.physicalProperties.sku;
                let cart_item = {
                    id: product_id,
                    price: parseFloat(price).toFixed(2),
                    sku: sku,
                    title: product_title
                };
                cart_details.push(cart_item);
            }
        }

        if (discount_code.length > 0)
        {
            let discount_code_options = {
                couponCode: discount_code
            };
            wixEcomBackend.currentCart.updateCurrentCart(discount_code_options);
        }
    
        if (redirect_to_page == "same_page")
        {
            if (local.getItem('upsale_bottom_plugin_success_message'))
            {
                local.removeItem('upsale_bottom_plugin_success_message');
            }

            local.setItem('upsale_bottom_plugin_success_message', JSON.stringify({widget_type: widget_type, widget_section: widget_section, cart_details: JSON.stringify(cart_details)}));
        
            await wixEcomFrontend.refreshCart();
            await wixEcomFrontend.openSideCart();
        }
        else if (redirect_to_page == "cart")
        {
            await wixEcomFrontend.refreshCart();
            await wixEcomFrontend.navigateToCartPage().then(() => 
            {
                if (local.getItem('upsale_bottom_plugin_success_message'))
                {
                    local.removeItem('upsale_bottom_plugin_success_message');
                }

                local.setItem('upsale_bottom_plugin_success_message', JSON.stringify({widget_type: widget_type, widget_section: widget_section, cart_details: JSON.stringify(cart_details)}));
            });
        }
        else
        {
            let checkout_options = {
                channelType: "WEB"
            };

            wixEcomBackend.currentCart.createCheckoutFromCurrentCart(checkout_options)
            .then(async (checkoutID) => 
            {
                await wixEcomFrontend.navigateToCheckoutPage(checkoutID.checkoutId)
                .then(() => 
                {
                    if (local.getItem('upsale_bottom_plugin_success_message'))
                    {
                        local.removeItem('upsale_bottom_plugin_success_message');
                    }

                    local.setItem('upsale_bottom_plugin_success_message', JSON.stringify({widget_type: widget_type, widget_section: widget_section, cart_details: JSON.stringify(cart_details)}));
                });
            });
        }
    })
    .catch((error) => {
        console.log(error);
    });
})